import { createContext } from 'react';
import { AddressDataType } from '../../service/save-address-service';
import { AvailableSlotsPayload } from '../../service/get-all-available-slots';
import { Address } from '../../service/stores-by-address-service';

export type PreferencesContextType = {
  fetchPreferences?: () => Promise<any>;
  fetchUpcomingOrders?: () => Promise<any>;
  fetchCityFromZipCode?: (zipcode: string) => Promise<any>;
  fetchAllAddresses?: () => Promise<any>;
  validateAddress?: (address: any) => Promise<any>;
  storeZipCodeLookup?: (address: Address) => Promise<any>;
  getStoreDetails?: (storeId: string) => Promise<any>;
  saveAddress?: (addressData: AddressDataType) => Promise<any>;
  deleteAddress?: (addressId: string) => Promise<any>;
  fetchSlotsInfo?: () => Promise<any>;
  slotsInfo?: object;
  updateSlotsInfo?: (slotsInfo: any) => Promise<any>;
  storeId?: string;
  preferencesData?: any;
  fetchAvailableSlotsInfo?: (storeId: AvailableSlotsPayload) => Promise<any>;
};
export const PreferencesContext = createContext<PreferencesContextType | null>(null);
